export default {
      id: "icon--gift-usage",
      viewBox: "0 0 18 20",
      url: __webpack_public_path__ + "redesign-sprite.svg#icon--gift-usage",
      toString: function () {
        return this.url;
      }
    }